import Vue from 'vue'
import Router from 'vue-router'
//避免导航冗余
const routerPush = Router.prototype.push
Router.prototype.push = function (location) {
  return routerPush.call(this, location).catch(error => error)
}
Vue.use(Router)
export default new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'index',
      component: resolve => (require(["@/components/index"], resolve)),
      redirect: "/home",
      children: [
        {
          path:"/question",
          name:"question",
          component:resolve => (require(["@/components/question"],resolve)),
          meta:{
            active:"题库"
          }
        },
        {
          path:"/questiondetail",
          name:"questiondetail",
          component:resolve => (require(["@/components/questiondetail"],resolve)), 
        },
        {
          path:"/report",
          name:"report",
          component:resolve => (require(["@/components/report"],resolve)),
          meta:{
            active:"文档"
          }
        },
        {
          path:"reportinfo",
          name:"reportinfo",
          component:resolve => (require(["@/components/reportinfo"],resolve)),
          meta:{
            active:"文档详情"
          }
        },
        {
          path:"/reportadd",
          name:"reportadd",
          component:resolve => (require(["@/components/reportadd"],resolve)),
          meta:{
            active:"文档添加"
          }
        },
        {
          path: "/home",
          name: "home",
          component: resolve => (require(['@/components/home'], resolve)),
          meta: {
            active: "首页"
          }
        },
        {
          path: "/sethome",
          name: "sethome",
          component: resolve => (require(['@/components/sethome'], resolve)),
          meta: {
            active: "设为首页"
          }
        },
        {
          path: "/answer",
          name: "answer",
          component: resolve => (require(['@/components/answer'], resolve)),
          meta: {
            active: "回答"
          }
        },
        {
          path: "/personcent",
          name: "personcent",
          component: resolve => require(['@/components/personcent'], resolve),
          meta: {
            active: "个人中心"
          }
        },
        {
          path: "/edituser",
          name: "edituser",
          component: resolve => require(['@/components/edituser'], resolve),
        }
      ]
    }, 

    {
      path: "/community",
      name: "community",
      component: resolve => (require(['@/components/community'], resolve)),
      meta: {
        active: "社区"
      },
      children: [
        {
          path: "/userinfo",
          name: "userinfo",
          component: resolve => (require(['@/components/userinfo'], resolve)),
          meta: {
            active: "用户信息"
          }
        },
        {
          path: "/communityindex",
          name: "communityindex",
          component: resolve => (require(['@/components/communityindex'], resolve)),
          meta: {
            active: "社区主页"
          }
        },
        {
          path: "/recommend",
          name: "recommend",
          component: resolve => (require(['@/components/recommend'], resolve)),
          meta: {
            active: "推荐社区"
          }
        },
        {
          path: "/selected",
          name: "selected",
          component: resolve => require(['@/components/selected'], resolve),
          meta: {
            active: "精选"
          }
        },
        {
          path: "/hot",
          name: "hot",
          component: resolve => require(['@/components/hot'], resolve),
          meta: {
            active: "热门小组"
          }
        },
        {
          path: "/details",
          name: "details",
          component: resolve => require(['@/components/details'], resolve),
          meta: {
            active: "帖子详情"
          }
        },
        {
          path: "/group",
          name: "group",
          component: resolve => require(['@/components/group'], resolve),
          meta: {
            active: "小组"
          }
        },
        {
          path: "/groupsetup",
          name: "groupsetup",
          component: resolve => require(['@/components/groupsetup'], resolve),
          meta: {
            active: "小组设置"
          }
        },
        {
          path: "/mygroup",
          name: "mygroup",
          component: resolve => require(['@/components/mygroup'], resolve),
          meta: {
            active: "我的小组"
          }
        },
        {
          path: "/addgroup",
          name: "addgroup",
          component: resolve => require(['@/components/addgroup'], resolve),
          meta: {
            active: "创建小组"
          }
        },
        {
          path: "/groupdetails",
          name: "groupdetails",
          component: resolve => require(['@/components/groupdetails'], resolve),
          meta: {
            active: "小组详情"
          }
        },
        {
          path: "/release",
          name: 'release',
          component: resolve => require(['@/components/release'], resolve),
          meta: {
            active: "发布"
          }
        }
      ]
    },
    {
      path: "/login",
      name: "login",
      component: resolve => require(['@/components/login'], resolve),
      meta: {
        active: "登录"
      }
    },
    {
      path: "/register",
      name: "register",
      component: resolve => require(['@/components/register'], resolve),
      meta: {
        active: "注册"
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js